export default {
  'title': 'Staff Management',
  'add': 'Add Staff',
  'list.username': 'Username',
  'list.email': 'Email',
  'list.role': 'Role',
  'list.actions': 'Actions',
  'list.edit': 'Edit',
  'list.delete': 'Delete',
  'list.fetchFailed': 'Failed to fetch staff list',
  'delete.confirm': 'Confirm Delete',
  'delete.content': 'Are you sure you want to delete this staff? This action cannot be undone.',
  'delete.success': 'Deleted successfully',
  'delete.failed': 'Failed to delete',
  'add.title': 'Add Staff',
  'edit.title': 'Edit Staff',
  'add.success': 'Added successfully',
  'add.failed': 'Failed to add',
  'edit.success': 'Updated successfully',
  'edit.failed': 'Failed to update',
  'role.admin': 'Admin',
  'role.staff': 'Staff',
  'tabs.basic': 'Basic Information',
  'tabs.permissions': 'Permissions',
  'form.username': 'Username',
  'form.username.required': 'Please enter username',
  'form.email': 'Email',
  'form.email.required': 'Please enter email',
  'form.email.invalid': 'Invalid email format',
  'form.password': 'Password',
  'form.password.required': 'Please enter password',
  'form.role': 'Role',
  'form.role.required': 'Please select a role',
  'form.assignedStore': 'Assigned Store',
  'form.permissionStore': 'Permission Store',
  'form.permissionStore.placeholder': 'Please select a store for permissions',
  'form.permissionStore.all': 'All Stores',
  'form.permissionStore.hint': 'Different permissions can be set for different stores. Selecting a store will only affect permissions for that store.',
  'stores.fetchFailed': 'Failed to fetch store list',
  'permissions.dashboard': 'Dashboard',
  'permissions.members': 'Member Management',
  'permissions.members.view': 'View Members',
  'permissions.members.create': 'Create Members',
  'permissions.members.edit': 'Edit Members',
  'permissions.members.delete': 'Delete Members',
  'permissions.members.export': 'Export Members',
  'permissions.cards': 'Gift Card Management',
  'permissions.cards.view': 'View Gift Cards',
  'permissions.cards.create': 'Create Gift Cards',
  'permissions.cards.edit': 'Edit Gift Cards',
  'permissions.cards.delete': 'Delete Gift Cards',
  'permissions.cards.export': 'Export Gift Cards',
  'permissions.vouchers': 'Voucher Management',
  'permissions.vouchers.view': 'View Vouchers',
  'permissions.vouchers.create': 'Create Vouchers',
  'permissions.vouchers.edit': 'Edit Vouchers',
  'permissions.vouchers.delete': 'Delete Vouchers',
  'permissions.vouchers.export': 'Export Vouchers',
  'permissions.selectAll': 'Select All',
  'permissions.hint': 'Selecting a main module will automatically select all its sub-permissions',
  'permissions.fetchFailed': 'Failed to fetch permission data',
  'staff.title': 'Staff Management',
  'staff.add': 'Add Staff',
  'staff.search': 'Search Staff',
  'staff.list.id': 'ID',
  'staff.list.username': 'Username',
  'staff.list.email': 'Email',
  'staff.list.role': 'Role',
  'staff.list.stores': 'Stores',
  'staff.list.noStore': 'No Store',
  'staff.list.actions': 'Actions',
  'staff.list.fetchFailed': 'Failed to fetch staff list',
  'staff.list.edit': 'Edit',
  'staff.list.delete': 'Delete',
  'staff.list.empty': 'No staff data',
  'staff.list.pagination.total': 'Total {total} items',
  'staff.form.username': 'Username',
  'staff.form.email': 'Email',
  'staff.form.password': 'Password',
  'staff.form.role': 'Role',
  'staff.form.permissionStore': 'Permission Stores',
  'staff.form.permissionStore.placeholder': 'Please select stores',
  'staff.form.permissionStore.all': 'All Stores',
  'staff.form.permissionStore.hint': 'Select stores to assign permissions',
  'staff.form.permissionStore.selected': 'Selected Stores',
  'staff.form.permissionStore.setting': '{storeName} Permission Settings',
  'staff.form.username.required': 'Please enter username',
  'staff.form.email.required': 'Please enter email',
  'staff.form.email.invalid': 'Invalid email format',
  'staff.form.password.required': 'Please enter password',
  'staff.form.role.required': 'Please select role',
  'staff.add.success': 'Staff added successfully',
  'staff.add.failed': 'Failed to add staff',
  'staff.edit.success': 'Staff updated successfully',
  'staff.edit.failed': 'Failed to update staff',
  'staff.delete.confirm': 'Are you sure you want to delete this staff?',
  'staff.delete.content': 'Are you sure you want to delete this staff? This action cannot be undone.',
  'staff.delete.success': 'Staff deleted successfully',
  'staff.delete.failed': 'Failed to delete staff',
  'staff.tabs.basic': 'Basic Info',
  'staff.tabs.permissions': 'Permissions',
  'staff.add.title': 'Add Staff',
  'staff.edit.title': 'Edit Staff',
  'staff.permissions.fetchFailed': 'Failed to fetch permissions',
  'staff.permissions.selectAll': 'Select All',
  'staff.permissions.members': 'Member Management',
  'staff.permissions.members.view': 'View Members',
  'staff.permissions.members.create': 'Create Members',
  'staff.permissions.members.edit': 'Edit Members',
  'staff.permissions.members.delete': 'Delete Members',
  'staff.permissions.members.export': 'Export Members',
  'staff.permissions.cards': 'Gift Card Management',
  'staff.permissions.cards.view': 'View Gift Cards',
  'staff.permissions.cards.create': 'Create Gift Cards',
  'staff.permissions.cards.edit': 'Edit Gift Cards',
  'staff.permissions.cards.delete': 'Delete Gift Cards',
  'staff.permissions.cards.export': 'Export Gift Cards',
  'staff.permissions.vouchers': 'Voucher Management',
  'staff.permissions.vouchers.view': 'View Vouchers',
  'staff.permissions.vouchers.create': 'Create Vouchers',
  'staff.permissions.vouchers.edit': 'Edit Vouchers',
  'staff.permissions.vouchers.delete': 'Delete Vouchers',
  'staff.permissions.vouchers.export': 'Export Vouchers',
  'staff.permissions.hint': 'Permissions will be applied to the selected store',
  'staff.permissions.clickStore': 'Click on a store tag to set permissions',
  'staff.permissions.noStoreSelected': 'Please select a store first',
  'staff.permissions.saveFailed': 'Failed to save permissions',
  'staff.permissions.partialSaveError': 'Some store permissions failed to save, please try again later',
  'staff.permissions.emptyPermissions': 'Store {stores} has no permissions set, please add at least one permission',
  'staff.role.admin': 'Admin',
  'staff.role.staff': 'Staff',
  'staff.role.manager': 'Manager',
  'staff.form.resetPassword': 'Reset Password',
  'staff.form.resetPassword.hint': 'Password will be reset after submission',
  'staff.form.newPassword': 'New Password',
  'staff.form.newPassword.required': 'Please enter new password',
  'staff.password.reset.success': 'Password reset successfully',
  'staff.password.reset.failed': 'Failed to reset password',
  'table.sort.desc': 'Click to sort descending',
  'table.sort.asc': 'Click to sort ascending',
  'table.sort.cancel': 'Cancel sort',
}; 